export enum UserType {
    STUDENT = 'student',
    INSTRUCTOR = 'instructor',
}
